/*eslint-env jquery*/
import React, { Component } from 'react'
import { attachmentService } from '../../_services/attachment.service'
import { toastr } from 'react-redux-toastr'
import { config } from '../../config'
const base_url = config.apiBaseUrl

class PicUploader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      previewImage: this.props.value,
      loading: false,
      logoId: '',
      value: this.props.value
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    if (this.props.defaultValue) {
      // if (this.props.value) {
      //   let file = this.props.value;
      //   if (file) {

      //     let reader = new FileReader();

      //     reader.onloadend = () => {
      //       this.setState({ previewImage: reader.result, loading: false });
      //     }
      //     reader.readAsDataURL(file);

      //   }
      // } else {
      this.setState({
        previewImage: base_url + this.props.defaultValue,
        loading: false
      })
      // }
    }
  }
  async componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        previewImage: base_url + this.props.defaultValue,
        loading: false
      })
      //     console.log(nextProps.value);

      //     let file = nextProps.value;
      //     if (file) {

      //       let reader = new FileReader();

      //       reader.onloadend = () => {
      //         this.setState({ previewImage: reader.result, loading: false });
      //       }
      //       reader.readAsDataURL(file);

      //     }
      //   } else if (nextProps.defaultValue) {
      //     // console.log(nextProps.defaultValue);

      //     this.setState({ previewImage: nextProps.defaultValue, loading: false });
    } else {
      this.setState({ previewImage: '', loading: false })
    }
  }

  _handleImageChange = e => {
    e.preventDefault()
    this.setState({ loading: true })
    //Generate Preview Image
    let files = Array.from(e.target.files)
    let file = e.target.files[0]
    if (file) {
      if (file.size > 153600) {
        toastr.error('حجم تصویر نباید بیشتر از 150 کیلوبایت باشد')
        this.setState({ loading: false })
      } else if (
        file.name
          .split('.')
          .pop()
          .toUpperCase() !== 'JPG' &&
        file.name
          .split('.')
          .pop()
          .toUpperCase() !== 'JPEG' &&
        file.name
          .split('.')
          .pop()
          .toUpperCase() !== 'PNG'
      ) {
        toastr.error('فقط تصاویر jpg پشتیبانی می شود')
        this.setState({ loading: false })
      } else {
        // var img = new Image();
        // img.onload = function() {
        //   console.log("This image has width "+this.width+"px and height "+this.height+"px.");
        // }
        // img.src = file;

        // this.props.onChange(file)

        const formData = new FormData()
        formData.append('file', file)
        // formData.append('width', '');
        // formData.append('height', '');
        formData.append('needCompresstion', false)
        // console.log(file);

        attachmentService
          .attach(formData)
          .then(res => {
            this.setState({ logoId: res.data.id, loading: false })
            // toastr.success('ثبت راننده حمل و نقل جدید', ' حمل و نقل جدید  "' + res.data.userName +  '" با موفقیت ثبت شد');
            // console.log(res.data);

            this.props.onChange(res.data)

            files.forEach((file, i) => {
              let reader = new FileReader()

              reader.onloadend = () => {
                this.setState({ previewImage: reader.result, loading: false })
              }
              reader.readAsDataURL(file)
            })
          })
          .catch(error => {
            // console.log(error)
            // this.handleError(error)
          })
      }
    }
  }

  getFileExtension(filename) {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
  }
  _handleClick = e => {
    var inputField = this.refs.fileField
    inputField.click()
  }
  // shouldComponentUpdate(){
  //   return false;
  // }

  render() {
    const { loading, previewImage } = this.state
    const { disabled } = this.props

    return (
      <div className="file-area-liner">
        <input
          ref="fileField"
          type="file"
          accept="image/*"
          onChange={this._handleImageChange}
          disabled={disabled}
        />
        <div className="file-dummy">
          <div className={'success ' + (previewImage === '' ? 'hidden' : '')}>
            {/* <img src={previewImage} alt="" className={"previewImage " + (previewImage === '' ? "hidden" : "")} /> */}
            <i
              className={
                'mdi mdi-check ' + (previewImage === '' ? 'hidden' : '')
              }
            />
          </div>
          <div className={'default ' + (previewImage !== '' ? 'hidden' : '')}>
            <span>{this.props.label} </span>
          </div>
        </div>
        {/* <a className="btn btn-primary btn-sm uploadBtn" onClick={this._handleClick}><i className="clicko-edit"></i></a> */}
        <input
          type="hidden"
          name={this.props.name}
          defaultValue={this.state.logoId}
        />
        {loading && (
          <div className="indicator">
            <div className="PicLoader" />
          </div>
        )}
      </div>
    )
  }
}
export default PicUploader
